import React, { useEffect, useState } from "react";
import axios from "axios";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default function HandleSubscribeModal({
  cancelModal,
  handleSubscribe,
  selectedProductId,
  selectedProd,
  id,
}) {
  //styled

  const [bookingProfileId, setBookingProfileId] = useState(0);
  const [profiles, setProfiles] = useState([]);
  const [membership, setMembership] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [err, setErr] = useState("");
  const { user } = useAuthContext();

  const handleSelectionChange = (event) => {
    const selectedId = parseInt(event.target.value, 10);
    setBookingProfileId(selectedId);
  };

  const removeMatchingProfiles = (profiles, membership) => {
    const membershipIds = membership.map((member) => member.profileId);
    return profiles.filter((profile) => !membershipIds.includes(profile.id));
  };

  useEffect(() => {
    const fetchProfiles = async () => {
      setIsLoading(true);
      try {
        setBookingProfileId(0);

        // Fetch memberships
        const membershipResponse = await axios.get(
          `${ApiConnectionString}/api/ClubMembers/${user.id}/${id}`,
          {
            headers: { Authorization: `Bearer ${user.token}` },
          }
        );
        setMembership(membershipResponse.data);

        // Fetch profiles
        const profileResponse = await axios.get(
          `${ApiConnectionString}/api/BookingProfiles?AppUserId=${user.id}`,
          {
            headers: { Authorization: `Bearer ${user.token}` },
          }
        );

        // Filter profiles based on memberships
        const filteredProfiles = removeMatchingProfiles(
          profileResponse.data,
          membershipResponse.data
        );
        setProfiles(filteredProfiles);

        // If only one profile is available after filtering, pre-select it
        if (filteredProfiles.length === 1) {
          setBookingProfileId(filteredProfiles[0].id);
        }
      } catch (error) {
        console.error("Error fetching profiles:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProfiles();
  }, [user.id, id]);

  const handleClick = async () => {

    if (bookingProfileId == 0) {
      setErr("Profile must be selected");
    } else {handleSubscribe(selectedProductId, bookingProfileId);}
  
  };

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
        </div>
      </div>
    );
  } else {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <div className="blueBanner">
            <p className="fw-bold m-2 p-2 fontSize20">
              Subscribe to {selectedProd.name}
            </p>
          </div>

          <button
            type="button"
            className="close-button"
            onClick={cancelModal}
            aria-label="Close"
          >
            &times;
          </button>
          <div>
            {membership.length > 0 ? (
              <div>
                <p>
                  The following profiles already have a membership to this club,
                  the same profile cannot subscribe to the same club more than
                  once
                </p>

                {membership.map((member) => (
                  <div key={member.Id} className="d-flex">
                    <p className="red-text fw-bold mx-2">
                      {" "}
                      {member.viewBookingProfile.username}
                    </p>{" "}
                    <p>{member.name}</p>
                  </div>
                ))}
              </div>
            ) : (
              <p>No memberships available.</p>
            )}
          </div>
          <p className="fw-bold">
            Select a profile that you want to subscribe to {selectedProd.name}{" "}
            with
          </p>
          {profiles.length > 0 ? (
            <>
              <select
                id="profile-select"
                value={bookingProfileId}
                onChange={handleSelectionChange}
              >
                <option value={0}>--Please choose a username--</option>
                {profiles.map((profile) => (
                  <option key={profile.id} value={profile.id}>
                    {profile.username}
                  </option>
                ))}
              </select>{" "}
              <button className="saveChanges-button mx-3" onClick={handleClick}>
                Subscribe
              </button>
              <p className="text-danger">{err}</p>
              <div className="send-modal-footer">
                <button
                  onClick={cancelModal}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                  Cancel
                </button>
              </div>
            </>
          ) : (
            <div>
              <p>All of your profiles are already subscribed to this club</p>
              <button className="" onClick={cancelModal}>
                Okay
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }
}
